import { useFeatureStaticMenuQuery } from 'generated/sanity-graphql';

import { IParsedItemUnavailableModalData, IUseFeatureStaticMenu, requiredKeys } from './types';
import { parseData } from './utils';

// Reads CMS copy for the item-unavailable modal, including the active reward flow.
export const useFeatureStaticMenu = (): IUseFeatureStaticMenu => {
  const FEATURE_STATIC_MENU_SINGLETON_ID = 'feature-static-menu-singleton';
  const { data, loading } = useFeatureStaticMenuQuery({
    variables: { featureStaticMenuId: FEATURE_STATIC_MENU_SINGLETON_ID },
  });

  const itemUnavailableModalData = data?.FeatureStaticMenu?.itemUnavailableModal;
  const itemUnavailableModal = parseData<IParsedItemUnavailableModalData>(
    itemUnavailableModalData,
    requiredKeys
  );

  return {
    itemUnavailableModal,
    featureStaticMenuLoading: loading,
  };
};
